/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/plm_appCommonService";

const initialState = {
  sample: {
    data: [],
    status: true,
    transportNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  
};


export const pdmSlice = createSlice({
  name: "pdm",
  initialState,
  reducers: {
    addTransportNr(state, action) {
      state.transport.transportNr = action.payload;
    },
    
  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(getTransportList.pending, (state, action) => {
  //       state.transport.status = true;
  //     })
  //     .addCase(getTransportList.fulfilled, (state, action) => {
  //       state.transport.data = action.payload.data;
  //       state.transport.pagination.page = action.payload.page;
  //       state.transport.pagination.per_page = action.payload.per_page;
  //       state.transport.pagination.total = action.payload.total;
  //       state.transport.status = false;
  //     })
    
      
  // },
});

export const {
  addTransportNr,
} = pdmSlice.actions;


export default pdmSlice.reducer;




export const getWorkflowInboxCards = createAsyncThunk('getWorkflowInboxCards', async () =>{
    // console.log(">> loaded getWorkflowInboxCards");
    const res = await ItemService.getWorkflowInboxCards({"workflowStatus": "Open"});
    return res.data;
})

export const getWorkflowOutboxCards = createAsyncThunk('getWorkflowOutboxCards', async () =>{
    // console.log(">> loaded getWorkflowOutboxCards");
    const res = await ItemService.getWorkflowInboxCards({"workflowStatus": "Closed"});
    return res.data;
})
